import "./ContactInfoPage.scss"

import {
  ABOUT_YOU_SAVE_PREFERENCES_BUTTON,
  ABOUT_YOU_TAB,
  BACK_BUTTON,
  CHANGE_EMAIL_BUTTON,
  CONTACT_TAB,
  INTERVAL_TIME,
  PROFILE_LABEL,
} from "../../constants/messages"
import { Banner, Button, TextTag as Text } from "../../atoms"
import React, { useState } from "react"
import {
  emailVerification,
  getAddressFromCoord,
  getUserData,
  updateAddress,
} from "../../redux/actionCreators/auth"
import {
  resendVerificationButton,
  verifyEmailAddressMessage,
  verifyEmailMessage,
} from "../../constants/validationMessages"

import AboutYou from "../../components/AboutYou/AboutYou"
import { ArrowLeftOutlined } from "@ant-design/icons"
import ContactYou from "../../components/ContactYou/ContactYou"
import { PageHeader } from "../../molecules/PageHeader"
import { Tabs } from "antd"
import _ from "../../utils/lodashUtils"
import { connect } from "react-redux"
import { useInterval } from "common-custom-hooks"
import { withRouter } from "react-router-dom"

const { TabPane } = Tabs

const ContactInfoPage = props => {
  const { user } = props
  const [selectedIndex, setSelectedIndex] = useState("0")
  const [changeText, setChangeText] = useState(false)

  const isEmailVerified = _.get(props.user, "email_verification_status")

  const handleSelect = index => {
    setSelectedIndex(index)
  }

  const handleTabChange = key => {
    setSelectedIndex(key)
  }

  const resendEmail = async () => {
    const token = localStorage.getItem("token")
    await props.emailVerification(token)
  }

  const setLocationData = async position => {
    // get geo co-ordinates as soon as they log in
    getAddressFromCoord(
      position.coords.latitude,
      position.coords.longitude
    ).then(data => {
      if (data && data.address) {
        props.updateAddress(data.address)
        setChangeText(true)
      }
    })
  }

  const setLocation = position => {
    setLocationData(position)
  }

  useInterval(() => {
    //get user data till primary signup email is verified
    if (props.user.email && !isEmailVerified) {
      props.getUserData(props.user.id)
    }
  }, INTERVAL_TIME)

  const goBackHandle = () => {
    props.history.push("/dashboard")
  }
  let prevPath = _.get(props.history.location, "state.fromLogin")
  const userDisplayName = _.get(user, "display_name", "")
  const isPrimarySignupPresent =
    (_.get(user, "signup_method") === "EMAIL" && !_.isEmpty(user, "email")) ||
    (_.get(user, "signup_method") === "PHONE" &&
      !_.isEmpty(user, "phone_number"))

  const takeToNextState = () => {
    props.history.push("/dashboard")
  }

  if (!prevPath) {
    prevPath = localStorage.getItem("isPathFromLogin") || false
  }

  return (
    <div id="ContactInfoPage">
      <div className="contact-tab">
        {user && user.email && !isEmailVerified ? (
          <Banner type="secondary">
            <div className="resendEmailContainer">
              <div className="flex-col emailText">
                <Text textType="sectionHeading">{verifyEmailMessage}</Text>
                <br />
                <Text textType="sectionTextPrimary" className="verify_email">
                  {verifyEmailAddressMessage}
                </Text>
              </div>
              <div className="btn-container">
                <Button className="resendEmailButton" onClick={resendEmail}>
                  {resendVerificationButton}
                </Button>
                <Button
                  className="changeEmailButton"
                  onClick={() => {
                    setSelectedIndex("1")
                  }}
                >
                  {CHANGE_EMAIL_BUTTON}
                </Button>
              </div>
            </div>
          </Banner>
        ) : null}

        <div className="back_btn">
          <div className="page_header">
            <PageHeader
              onClick={goBackHandle}
              btnSize="small"
              icon={<ArrowLeftOutlined />}
              btnText={BACK_BUTTON}
              headerText={PROFILE_LABEL}
              showButton={!prevPath && userDisplayName}
            />
          </div>
        </div>

        <div className="container">
          <Tabs
            defaultActiveKey={selectedIndex}
            activeKey={selectedIndex}
            onChange={handleSelect}
          >
            <TabPane tab={ABOUT_YOU_TAB} key="0">
              <div>
                <AboutYou
                  changeTab={key => {
                    handleTabChange(key)
                  }}
                />
              </div>
            </TabPane>
            <TabPane tab={CONTACT_TAB} key="1">
              <div>
                <ContactYou />
              </div>
            </TabPane>
            {/* <TabPane tab={INTEGRATION} key="2">
            <div>
              <IntegrationSetupPage
                setLocation={setLocation}
                changeText={changeText}
              />
            </div>
          </TabPane> */}
          </Tabs>
        </div>
        {(prevPath || _.isEmpty(userDisplayName)) && (
          <div className="aboutYouButton">
            <Button
              btnSize="large"
              btnType="primary"
              onClick={takeToNextState}
              className="login-form-button"
              disabled={_.isEmpty(userDisplayName) && isPrimarySignupPresent}
            >
              {ABOUT_YOU_SAVE_PREFERENCES_BUTTON}
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  user: state.auth.user,
})
export default connect(mapStateToProps, {
  emailVerification,
  updateAddress,
  getUserData,
})(withRouter(ContactInfoPage))
